import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {ConferenceModel} from './Conference.model';

@injectable()
export class ConferenceFactory
  implements BaseDomainFactory<ConferenceModel, ConferenceModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: ConferenceModel.Props): ConferenceModel {
    return this.modelsRegistry.put(new ConferenceModel(props));
  }
}
